import { WorkflowElementType } from '../../../models/Enums/workflow-element-type';

export class SearchDialogResult {
    public constructor(
        public elementType: WorkflowElementType,
        public elementId: number
    ) {}
}
